import { Component } from 'react'

import { navigateTo, Obj } from 'scrivito'

import { ErrorCode, ErrorVariant } from './error/constants'
import { ErrorPage } from './error/Errors'
import { Spinner } from './Spinner/Spinner'
import { Button } from '@/Atomic/Molecules/Button'
import { APIErrorResponse } from '@/Data/types'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  variant?: ErrorVariant
  isResetting: boolean
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    this.state = { hasError: false, isResetting: false }
  }

  static getDerivedStateFromError(error: APIErrorResponse) {
    if (error.code === ErrorCode.AccessNoRead) {
      return { hasError: true, variant: ErrorVariant.AccessDeniedError }
    }

    return { hasError: true, variant: ErrorVariant.UnknownError }
  }

  resetError() {
    this.setState({ isResetting: true })
    navigateTo(Obj.root())
    setTimeout(() => {
      this.setState({ hasError: false, isResetting: false })
    }, 2000)
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          variant={this.state.variant}
          content={
            this.state.isResetting ? (
              <Spinner />
            ) : (
              <Button
                title="Back to home page"
                onClick={() => this.resetError()}
                disabled={this.state.isResetting}
              />
            )
          }
        />
      )
    }

    return this.props.children
  }
}
